import React, { useState, useEffect } from "react";
import { Button, Modal, Box, TextField, Typography, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Card, CardContent, CardActions, useMediaQuery } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { InputAdornment } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import SearchIcon from "@mui/icons-material/Search";

const CustomerForm = ({ totalPrice, setTotalPrice, onSelectCustomer }) => {
  const isMobileOrTab = useMediaQuery("(max-width:1024px)");
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [customers, setCustomers] = useState([]);
  
  const [selectedCustomerIndex, setSelectedCustomerIndex] = useState(null);
  const [duplicatePhoneOpen, setDuplicatePhoneOpen] = useState(false);

  const popupclose = () => setOpen1(false);
  const popupopen = (index) => {
    setSelectedCustomerIndex(index);
    setOpen1(true);
  };

  // Load customers from localStorage on page load
  useEffect(() => {
    const savedCustomers = JSON.parse(localStorage.getItem("customers")) || [];
    setCustomers(savedCustomers);
  }, []);

  // Save customers to localStorage when customers array changes
  useEffect(() => {
    localStorage.setItem("customers", JSON.stringify(customers));
  }, [customers]);

  // Open and Close Modal
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    fetchCustomers();
  }, []);
  
  const fetchCustomers = async () => {
    try {
      const response = await fetch("https://enzo-matr.onrender.com/customer_bonus");
      const data = await response.json();
  
      console.log("Fetched Customers:", data); // ✅ Check if the data is correct
  
      setCustomers(data); // ✅ Ensure state is updated
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };
  
  
  const handleAddCustomer = async () => {
    if (customerName && customerPhone) {
      // Check if phone already exists in backend
      try {
        const response = await fetch(`https://enzo-matr.onrender.com/customer_bonus?phone=${customerPhone}`);
        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          setDuplicatePhoneOpen(true);
          return;
        }
      } catch (error) {
        console.error("Error checking phone number:", error);
      }

      const newCustomer = { 
        name: customerName, 
        phone: customerPhone, 
        state: "New Customer"
      };

      try {
        const response = await fetch("https://enzo-matr.onrender.com/customer_bonus", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(newCustomer),
        });

        if (response.ok) {
          setCustomerName("");
          setCustomerPhone("");
          handleClose();
          fetchCustomers();
        } else {
          console.error("Failed to add customer");
        }
      } catch (error) {
        console.error("Error adding customer:", error);
      }
    }
  };
  

  const handleGetCustomer = async (index) => {
    if (index === null || index === undefined) {
      alert("Please select a customer!");
      return;
    }
  
    const selectedCustomer = customers[index];
  
    if (!selectedCustomer) {
      console.error("No customer selected for discount");
      return;
    }
  
    try {
      const response = await fetch(`https://enzo-matr.onrender.com/customer_bonus/${selectedCustomer._id}`);
  
      if (!response.ok) {
        throw new Error("Failed to fetch customer details");
      }
  
      const customerData = await response.json();
      console.log("✅ Fetched Customer:", customerData);
  
      // ✅ Store customer details and pass to Invoice
      if (onSelectCustomer) {
        onSelectCustomer({
          name: customerData.name,
          idNumber: customerData.idNumber,
          state: customerData.state
        });
      } else {
        console.error("onSelectCustomer function is missing!");
      }
  
      // ✅ Apply discount
      applyDiscount(index);
  
    } catch (error) {
      console.error("❌ Error fetching customer details:", error);
      alert("Error fetching customer details. Please try again.");
    }
  };
  
  // Handle Search
  const filteredCustomers = customers.filter((customer) =>
    customer.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    customer.idNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
    customer.phone.toLowerCase().includes(searchQuery.toLowerCase())
  
  );

  const handleIncreasePoints = async () => {
    if (selectedCustomerIndex !== null) {
      const selectedCustomer = customers[selectedCustomerIndex];
  
      if (!selectedCustomer) {
        console.error("No customer selected for adding points");
        return;
      }
  
      const previousPoints = selectedCustomer.points || 0;
      const addedPoints = Math.ceil(previousPoints * 0.30);
      const updatedPoints = previousPoints === 0 ? 10 : previousPoints + addedPoints;
  
      try {
        const response = await fetch(`https://enzo-matr.onrender.com/customer_bonus/${selectedCustomer._id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ points: updatedPoints }),
        });
  
        const data = await response.json();
        if (response.ok && data.success) {
          console.log("Points successfully updated", data.customer);
          await fetchCustomers(); // Refresh UI
  
          // ✅ Change state to "Regular" if points are added
          if (selectedCustomer.state === "New Customer") {
            await fetch(`https://enzo-matr.onrender.com/customer_bonus/${selectedCustomer._id}`, {
              method: "PUT",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ state: "Regular" }),
            });
          }
  
        } else {
          console.error("Failed to update points:", data);
        }
      } catch (error) {
        console.error("Error updating points:", error);
      }
    }
    popupclose();
  };
    
  const handleUsePoints = async (usedPoints) => {
    if (selectedCustomerIndex !== null) {
      const selectedCustomer = customers[selectedCustomerIndex];
  
      if (!selectedCustomer) {
        console.error("No customer selected to use points");
        return;
      }
  
      const currentPoints = selectedCustomer.points || 0; // Ensure we consider 0
      if (usedPoints > currentPoints) {
        alert("Not enough points to use!");
        return;
      }
  
      const updatedPoints = currentPoints - usedPoints; // Deduct used points
  
      try {
        const response = await fetch(`https://enzo-matr.onrender.com/customer_bonus/${selectedCustomer._id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ points: updatedPoints }),
        });
  
        const data = await response.json();
        console.log("API Response:", data);
  
        if (response.ok && data.success) {
          console.log("Points successfully deducted", data.customer);
          await fetchCustomers(); // Refresh UI
        } else {
          console.error("Failed to deduct points:", data);
        }
      } catch (error) {
        console.error("Error deducting points:", error);
      }
    }
    popupclose();
  };
  
  const applyDiscount = async (index) => {
    if (index !== null) {
      const selectedCustomer = customers[index];
  
      if (!selectedCustomer) {
        console.error("No customer selected for discount");
        return;
      }
  
      const discountAmount = selectedCustomer.points / 10; // Convert points to discount
      const newTotal = totalPrice - discountAmount;
  
      setTotalPrice(newTotal > 0 ? newTotal : 0);
  
      const updatedPoints = selectedCustomer.points - Math.floor(discountAmount * 10); // Deduct only the used points
  
      try {
        const response = await fetch(`https://enzo-matr.onrender.com/customer_bonus/${selectedCustomer._id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ points: updatedPoints > 0 ? updatedPoints : 0 }), // Ensure no negative points
        });
  
        if (response.ok) {
          fetchCustomers();
          console.log("Points successfully updated after discount");
        } else {
          console.error("Failed to update points");
        }
      } catch (error) {
        console.error("Error updating points:", error);
      }
    } else {
      console.error("No customer selected for discount");
    }
  };
  
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: isMobileOrTab ? "90vw" : "630px",
        height: isMobileOrTab ? "auto" : "130px",
        marginTop: isMobileOrTab ? 1 : "-130px",
        marginLeft: isMobileOrTab ? 0 : "120px",
        padding: "10px",
        boxShadow: 2,
        borderRadius: "20px",
        background: "white",
      }}
    >
      {/* Search Bar and Add Customer Button */}
      <Box sx={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        mb: 1,
        flexDirection: "row" // Always horizontal, even on mobile/tablet
      }}>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search Customer"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{
            width: isMobileOrTab ? "90vw" : "290px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
            },
          }}
        />
        <IconButton
          sx={{
            bgcolor: "black",
            borderRadius: "8px",
            width: "35px",
            height: "37px",
            color: "white",
            "&:hover": { bgcolor: "gray" },
          }}>
          <SearchIcon sx={{ fontSize: "20px" }} />
        </IconButton>
        <Button
          variant="contained"
          startIcon={<AddIcon sx={{ fontSize: isMobileOrTab ? "14px" : "16px" }} />}
          onClick={handleOpen}
          sx={{
            width: isMobileOrTab ? "90vw" : "262px",
            height: isMobileOrTab ? "36px" : "43px",
            textTransform: "none",
            backgroundColor: "#20B2AA",
            borderColor: "black",
            fontFamily: "'PT Serif', serif",
            fontWeight: "bold",
            fontSize: isMobileOrTab ? "16px" : "18px",
            borderWidth: "1px",
            borderStyle: "solid",
            color: "black",
            borderRadius: "10px"
          }}>
          Add New Customer
        </Button>
      </Box>

      {/* Scrollable Customer List */}
      <Box sx={{
        height: isMobileOrTab ? "auto" : "50px",
        maxHeight: isMobileOrTab ? "180px" : "50px",
        overflowY: "auto",
        mt: 0,
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": { display: "none" }
      }}>
        {filteredCustomers.map((customer, index) => (
          <Card key={customer._id} sx={{
            mb: isMobileOrTab ? 1 : 0,
            width: isMobileOrTab ? "95vw" : "auto"
          }}>
            <CardContent sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: -1,
              flexDirection: isMobileOrTab ? "column" : "row",
              gap: isMobileOrTab ? 1 : 0
            }}>
              <Typography sx={{ color: "black", fontFamily: "caladea", fontSize: isMobileOrTab ? "16px" : "20px" }}>
                ID: {customer.idNumber}
              </Typography>
              <Typography sx={{ color: "black", fontFamily: "caladea", fontSize: isMobileOrTab ? "16px" : "20px" }}>
                {customer.name}
              </Typography>
              <Typography sx={{ color: "black", fontFamily: "caladea", fontSize: isMobileOrTab ? "16px" : "20px" }}>
                {customer.phone}
              </Typography>
              <Typography sx={{ color: "black", fontFamily: "caladea", fontSize: isMobileOrTab ? "16px" : "20px" }}>
                {customer.points} Points
              </Typography>
              <CardActions sx={{ flexDirection: isMobileOrTab ? "row" : "row" }}>
                <Button
                  variant="contained"
                  onClick={() => popupopen(index)}
                  sx={{
                    width: isMobileOrTab ? "60px" : "80px",
                    height: isMobileOrTab ? "28px" : "30px",
                    fontFamily: "'PT Serif', serif",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    background: "#2f2f2f",
                    borderColor: "black",
                    fontSize: isMobileOrTab ? "14px" : "18px",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    color: "white",
                  }}
                >
                  Add
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  sx={{
                    width: isMobileOrTab ? "60px" : "80px",
                    height: isMobileOrTab ? "28px" : "30px",
                    fontFamily: "'PT Serif', serif",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    background: "#20B2AA",
                    borderColor: "black",
                    fontSize: isMobileOrTab ? "14px" : "18px",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    color: "black",
                  }} onClick={() => handleGetCustomer(index)}
                >
                  GET
                </Button>
              </CardActions>
            </CardContent>
          </Card>
        ))}
      </Box>

      {/* Add Bonus Points Dialog */}
      <Dialog
        open={open1}
        onClose={popupclose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "20px",
            width: isMobileOrTab ? "98vw" : "550px",
            height: isMobileOrTab ? "auto" : "350px"
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            color: "#d32f2f",
            fontSize: isMobileOrTab ? "28px" : "46px",
            textTransform: "uppercase",
            textDecoration: "underline",
            fontFamily: "caladea"
          }}
        >
          Add Bonus Point
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center" }}>
          <Typography variant="body1" sx={{
            fontSize: isMobileOrTab ? "16px" : "22px",
            ml: 2, mr: 2, mb: 4, mt: -1,
            fontFamily: "Arial",
            fontWeight: "bold"
          }}>
            Are you sure you want to add bonus points to {customers[selectedCustomerIndex]?.name}?
          </Typography>
          <Typography variant="body2" sx={{
            fontSize: isMobileOrTab ? "15px" : "19px",
            color: "black",
            fontFamily: "caladea"
          }}>
            Make sure to click <strong style={{ color: "#d32f2f" }}>DONE</strong> Bill before adding Bonus Points
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: 2 }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#25bdbe",
              mb: 2,
              padding: isMobileOrTab ? "10px" : "20px",
              color: "black",
              fontWeight: "bold",
              textTransform: "none",
              width: isMobileOrTab ? "90vw" : "240px",
              height: isMobileOrTab ? "40px" : "60px",
              fontFamily: "caladea",
              fontSize: isMobileOrTab ? "16px" : "22px",
              borderRadius: 3
            }}
            onClick={handleIncreasePoints}
          >
            ENTER POINTS
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#2f2f2f",
              mb: 2,
              color: "white",
              fontWeight: "bold",
              textTransform: "none",
              width: isMobileOrTab ? "90vw" : "240px",
              fontFamily: "caladea",
              height: isMobileOrTab ? "40px" : "60px",
              borderRadius: 3,
              fontSize: isMobileOrTab ? "16px" : "22px"
            }}
            onClick={popupclose}
          >
            CANCEL
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Customer Modal */}
      <Modal open={open} onClose={handleClose} aria-labelledby="add-customer-modal">
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobileOrTab ? "98vw" : "470px",
            height: isMobileOrTab ? "auto" : "310px",
            bgcolor: "background.paper",
            boxShadow: 25,
            p: 4,
            borderRadius: 7,
          }}
        >
          <Typography variant="h6" sx={{
            textAlign: "center",
            mb: 3, mt: 0,
            fontFamily: "'PT Serif', serif",
            fontSize: isMobileOrTab ? "22px" : "35px",
            fontWeight: "bold",
            color: "black"
          }}>
            Add New Customer
          </Typography>

          <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 3
          }}>
            <TextField
              fullWidth
              placeholder="Enter Customer Name"
              variant="outlined"
              size="small"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonIcon
                      sx={{
                        fontSize: isMobileOrTab ? "22px" : "35px",
                        fontFamily: "'PT Serif', serif",
                        color: "black",
                        marginLeft: "15px",
                        marginRight: "5px",
                      }}
                    />
                  </InputAdornment>
                ),
              }}
              sx={{
                height: isMobileOrTab ? "40px" : "60px",
                "& .MuiOutlinedInput-root": {
                  height: isMobileOrTab ? "40px" : "60px",
                  borderRadius: "10px",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  borderColor: "black"
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "'PT Serif', serif",
                  color: "black",
                  opacity: 1,
                  fontSize: isMobileOrTab ? "13px" : "16px",
                }
              }}
            />
          </Box>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 5
          }}>
            <TextField
              fullWidth
              placeholder="Enter Phone Number"
              variant="outlined"
              size="small"
              value={customerPhone}
              onChange={(e) => {
                // Only allow digits and limit to 10 characters
                const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                setCustomerPhone(val);
              }}
              inputProps={{
                maxLength: 10,
                inputMode: "numeric",
                pattern: "[0-9]*"
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PhoneIcon
                      sx={{
                        fontSize: isMobileOrTab ? "18px" : "25px",
                        color: "white",
                        fontFamily: "'PT Serif', serif",
                        backgroundColor: "black",
                        borderRadius: "50%",
                        marginLeft: "15px",
                        marginRight: "14px",
                        border: "1px solid black",
                      }}
                    />
                  </InputAdornment>
                ),
              }}
              sx={{
                height: isMobileOrTab ? "40px" : "60px",
                "& .MuiOutlinedInput-root": {
                  height: isMobileOrTab ? "40px" : "60px",
                  borderRadius: "8px",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  borderColor: "black"
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "black",
                  opacity: 1,
                  fontFamily: "'PT Serif', serif",
                  fontSize: isMobileOrTab ? "13px" : "16px",
                }
              }}
            />
          </Box>

          {/* Buttons */}
          <Box sx={{
            display: "flex",
            flexDirection: isMobileOrTab ? "column" : "row",
            justifyContent: "space-evenly",
            gap: isMobileOrTab ? 1 : 0
          }}>
            <Button variant="contained"
              onClick={handleAddCustomer}
              sx={{
                width: isMobileOrTab ? "90vw" : "220px",
                height: isMobileOrTab ? "40px" : "50px",
                fontSize: isMobileOrTab ? "15px" : "19px",
                fontWeight: "bold",
                backgroundColor: "#20B2AA",
                color: "black",
                fontFamily: "'PT Serif', serif",
                borderRadius: "8px"
              }}>
              ADD CUSTOMER
            </Button>
            <Button
              variant="contained"
              onClick={handleClose}
              sx={{
                width: isMobileOrTab ? "90vw" : "220px",
                height: isMobileOrTab ? "40px" : "50px",
                fontSize: isMobileOrTab ? "15px" : "19px",
                fontWeight: "bold",
                fontFamily: "'PT Serif', serif",
                backgroundColor: "#696969",
                color: 'white',
                borderRadius: "8px"
              }}
            >
              CANCEL
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Duplicate Phone Alert Dialog */}
      <Dialog
        open={duplicatePhoneOpen}
        onClose={() => setDuplicatePhoneOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ color: "#d32f2f", fontWeight: "bold", textAlign: "center" }}>
          Customer Already Registered
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ textAlign: "center" }}>
            This phone number is already registered. Please use a different number.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={() => setDuplicatePhoneOpen(false)}
            sx={{ backgroundColor: "#20B2AA", color: "black", fontWeight: "bold" }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CustomerForm;